import React from 'react'
import { GatsbyImage, getImage } from 'gatsby-plugin-image'
import { Link } from 'gatsby'
import parser from 'html-react-parser'

export default function Content6({ data }) {
    const { content6ButtonText, content6Text, content6ButtonLink, content6Title, content6Image, content6ButtonExternalLink } = data
    return (
        <div className='image-radius-wrap about-our-team-sec light-grey-bg leading-g-c-wrap'>
            <div className='container'>
                <div className='row'>
                    <div className='col-md-7'>
                        <div className='image-radius-content global-img-content-rt-sec'>
                            <div className='lead-global-c-sec'>
                                <h2 className='heading-level-2 blue-color'>
                                    {content6Title && parser(content6Title)}
                                </h2>
                                <div className='image-radius-patrn-1 grey-circle-ptrn-col hide-desk'>
                                    <GatsbyImage
                                        image={getImage(content6Image?.localFile)}
                                        alt='image'
                                    />
                                </div>
                                {content6Text && parser(content6Text)}
                                {content6ButtonExternalLink ? (
                                    <a href={content6ButtonExternalLink} className="btn blue-btn">
                                        {content6ButtonText}
                                    </a>
                                ) : content6ButtonLink ? (
                                    <Link
                                        to={content6ButtonLink.uri}
                                        className='btn blue-btn'
                                    >
                                        {content6ButtonText}
                                    </Link>
                                ) : null}
                            </div>
                        </div>
                    </div>
                    <div className='col-md-5'>
                        <div className='image-radius-patrn-1 grey-circle-ptrn-col hide-mobile'>
                            <GatsbyImage
                                image={getImage(content6Image?.localFile)}
                                alt='image'
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
